import type { Result } from '@siloreal:shared:sdk/core';

import * as SDK from '@siloreal:shared:sdk';
const { ok, err } = SDK.core;

import * as v from 'valibot';

const DEFAULT_MESSAGES = { unknown: 'Error desconocido.' };

/**
 * Convierte el resultado de una validación de Valibot en un tipo Result.
 *
 * @template TOutput - El tipo del valor en el caso en el que fue validado exitosamente
 * @param result - El resultado de `v.safeParse()` de Valibot
 * @returns Un `Result` con el valor validado o el mensaje de error
 *
 * @example
 * ```typescript
 * const schema = v.string();
 * const result = v.safeParse(schema, "hello");
 * const validationResult = toValidationResult(result); // Result<string, string>
 * ```
 */
export function toValidationResult<TOutput>(
  result: v.SafeParseResult<v.BaseSchema<unknown, TOutput, v.BaseIssue<unknown>>>
): Result<TOutput, string> {
  return result.success ? ok(result.output) : err(result.issues[0]?.message ?? DEFAULT_MESSAGES.unknown);
}
